module.exports = __webpack_public_path__ + "img/unknown.e3d93cde.svg";